import {createAction, props} from "@ngrx/store";

export const AppActions = {
  public: {
    navigateToRuleWithId: createAction(
      '[App] navigateToRuleWithId',
      props<{
        id: string
      }>(),
    ),

    navigateToRules: createAction(
      '[App] navigateToRules',
    )
  }
}
